import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  styled,
} from "@mui/material";

const CustomRadio = styled(Radio)(({ theme }) => ({
  padding: 4,
  "&.Mui-checked": {
    color: theme.palette.ethicsBlue.main,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "& .MuiSvgIcon-root": {
    fontSize: 18,
    borderRadius: "50%",
  },
}));

export const Radios = ({
  text,
  value,
  onChangue,
  options = [],
  size = "small",
  fontSize = 13,
  sxLabel = {},
  sxOption = {},
  required = false,
  isValid = null,
  showSuccessValidation,
  helperText = "",
  disabled = false,
  name,
  ...rest
}) => {
  const returnColor = () => {
    if (isValid === false) return "error.main";
    if (isValid === true && showSuccessValidation) return "success.main";
    return "dark.main";
  };

  return (
    <FormControl component="fieldset" error={isValid === false}>
      <FormLabel
        component="legend"
        sx={{
          fontWeight: 600,
          color: returnColor(),
          ...sxLabel,
        }}
      >
        {text}
        {required && " *"}
      </FormLabel>

      <RadioGroup
        name={name || text}
        value={value}
        onChange={(e, val) => onChangue(val)}
        sx={{ px: 2 }}
        {...rest}
      >
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            label={opt.label}
            control={<CustomRadio size={size} />}
            disabled={disabled}
            sx={{
              "& .MuiTypography-root": {
                fontWeight: 600,
                fontSize: fontSize,
                color: "secondary.main",
              },
              ...sxOption,
            }}
          />
        ))}
      </RadioGroup>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
